import type { CustomFieldValueObject } from '@djust-b2b/djust-front-sdk/lib/interfaces/models/custom-field.js';
import type { AccountGetters } from './types';

export function useAccountGetters(): AccountGetters {
  // Getters Account
  const getAccountId = (account: CustomerAccount): string => account.id;

  const getAccountExternalId = (account: CustomerAccount): string => account.externalId;

  const getAccountName = (account: CustomerAccount): string => account.name;

  const getAccountManager = (account: CustomerAccount): string => account.accountManager;

  const getAccountWebsite = (account: CustomerAccount): string => account.website;

  const getCompanyRegistrationName = (account: CustomerAccount): string =>
    account.companyRegistrationName;

  const getBusinessRegistrationNumber = (account: CustomerAccount): string =>
    account.businessRegistrationNumber;

  const getVatNumber = (account: CustomerAccount): string => account.vatNumber;

  const getStatus = (account: CustomerAccount): string => account.status;

  const getPaymentType = (account: CustomerAccount): string => account.paymentType;

  const getMainContacts = (account: CustomerAccount): AccountContact[] => account.mainContacts;

  const getAddresses = (account: CustomerAccount): AccountAddress[] => account.addresses;

  const getCustomerTags = (account: CustomerAccount): AccountCustomerTagName[] =>
    account.customerTags;

  const getShippingAddresses = (account: CustomerAccount): AccountAddress[] =>
    account.addresses.filter((address: Address) => address.shipping);

  const getBillingAddresses = (account: CustomerAccount): AccountAddress[] =>
    account.addresses.filter((address: Address) => address.billing);

  const getCustomFieldValueById = (account: CustomerAccount, id: string) =>
    account.customFieldValues.find((cf: CustomFieldValueObject) => cf.customField.externalId === id)
      ?.value.value;

  return {
    getAccountId,
    getAccountExternalId,
    getAccountName,
    getAccountManager,
    getAccountWebsite,
    getCompanyRegistrationName,
    getBusinessRegistrationNumber,
    getVatNumber,
    getStatus,
    getPaymentType,
    getMainContacts,
    getAddresses,
    getCustomerTags,
    getShippingAddresses,
    getBillingAddresses,
    getCustomFieldValueById,
  };
}
